module.exports = __webpack_public_path__ + "img/MapPicsTreasureIsland.af0066f1.webp";